// Generates an assignment YAML of type v2_match (the two-column pairing
// runner) out of the same `word - переклад` list every other words generator
// eats.
//
// Match is WordCards' data shape with a third runner over it, so this is the
// twin of `word-wordcards.js` / `word-memo.js`: only the word tag is emitted
// and the EN↔UA pairing is resolved from the vocabulary bank at render time.
// Unlike memo there is no `pairs` knob — the runner plays the whole pack, four
// pairs to a round, so the word count *is* the length of the game. Which makes
// `limit` the only dial worth having here.
//
// converts a text like:
// word - переклад
// word - переклад
//
// to:
// version: 2
// type: match
// name: Topic match
// level: a1
// questions:
//   - [[[word]]]
//   - [[[word]]]

import { yamlScalar } from './yaml'

// Two words is the floor the backend validator enforces: with one pair there
// is nothing to match it against. Below that we emit nothing rather than a
// YAML the teacher would have to debug on save.
const MIN_WORDS = 2

export function wordMatchGenerator(rawText, topic, levelString, limit, shuffle = true) {
  const level = levelString.toUpperCase()
  const lines = rawText.split('\n')

  let words = lines.map((line) => {
    const [word,] = line.split(' - ')
    return word && word.trim() ? `[[[${word.trim()}]]]` : null
  }).filter((w) => w)

  // shuffle words
  if (shuffle) {
    for (let i = words.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [words[i], words[j]] = [words[j], words[i]]
    }
  }

  words = words.slice(0, limit || words.length)

  if (words.length < MIN_WORDS) {
    return null
  }

  const content = `version: 2
type: match
name: ${yamlScalar(`${topic} match`)}
level: ${level}
questions:
  - ${words.join('\n  - ')}
`
  return content
}
